/**
 * Describes environment types related to process.env.NODE_ENV and some custom types
 */
export default Object.freeze({
  production: 'production',
  development: 'development',
  unit: 'unit',
  e2e: 'e2e',
})
